var QueryPrayer = (function($) {

  var _s = {
    container: '.chm-block-query-prayer',
    requests: '.chm-block-query-prayer__requests',
    request: '.chm-block-query-prayer__request',
    pray: '.chm-block-query-prayer .js-Pray',
    prayer_count: '.chm-block-query-prayer__request-prayers-count',
    page_numbers: '.chm-block-query-prayer a.page-numbers',
  };

  var _init = function() {
    _bindEvents();
  };

  // ### Events
  var _bindEvents = function() {

    // Pray
    $(document).on('click', _s.pray, function() {
      let $this = this;
      let requestID = $(this).parents(_s.request).data('request-id');
      let prayer_count_el = $(this).parents(_s.request).find(_s.prayer_count);
      
      $.ajax({
        method: 'POST',
        url: wp_ajax.url, // This variable is set in /inc/lib/dependencies.php
        data: {
          action:'jump_update_prayers',
          request_id: requestID
        },
        success: function(data) {
          console.log('Current Prayers for Request '+requestID+': '+data);

          let count_anim = new countUp.CountUp(prayer_count_el[0], data, {
            startVal: prayer_count_el.html(),
            duration:1,
          });
          count_anim.start();

          $($this).html('Thank You!').prop('disabled', true).addClass('disabled');
        },
        error: function(error) {
          console.log(error);
        }
      });

    });

    // New Page Click
    $(document).on('click', _s.page_numbers, function(e) {
      e.preventDefault();
      let parent_container = $(this).parents(_s.container);
      let param = $(this).attr('href').split("?");
      var page;

      if ( param[1] ) {
        page = param[1].split("=");
        page = page[1];
      } else {
        param[0] = param[0].slice(0, -1); // remove last slash
        page = param[0].substring(param[0].lastIndexOf('/') + 1); // Get everything after the new 'last' slash
      }


      $.ajax({
        method: 'POST',
        url: wp_ajax.url, // This variable is set in /inc/lib/dependencies.php
        data: {
          action:'jump_get_prayer_requests',
          page: parseInt(page)
        },
        success: function(data) {

          anime({
            targets: _s.request,
            opacity: [1, 0],
            translateY: [0, '-1rem'],
            duration: 100,
            delay: anime.stagger(100),
            easing: 'easeOutQuad'
          });
          
          setTimeout(function() {
            // Clear requests container and append new content
            $(_s.requests).html('').append(data);
            // Clear current pagination container
            parent_container.find('.pagination-container').html('');
            // Take the new pager and move it to the pagination container
            $(_s.requests).find('.pager').appendTo(parent_container.find('.pagination-container'));

            anime({
              targets: _s.request,
              opacity: [0, 1],
              translateY: ['4rem', 0],
              duration: 500,
              delay: anime.stagger(100),
              easing: 'easeOutQuad'
            });
          }, 1000);

        },
        error: function(error) {
          console.log(error);
        }
      });
    });

  };



  return {
    init: _init
  };

})(jQuery);